import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { UsuariosService } from 'src/app/core/services/usuarios.service';
import { ValidatorService } from 'src/app/shared/validator/validator.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-reset-pass',
  templateUrl: './reset-pass.component.html',
  styleUrls: ['./reset-pass.component.scss'],
})
export class ResetPassComponent implements OnInit {
  public resetpassForm: FormGroup;
  public showSpinner: boolean;
  public year: number = new Date().getFullYear();

  equals: boolean = false;

  token = '';
  email = '';

  constructor(
    private activateRouter: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private usuarioService: UsuariosService,
    private snackBar: MatSnackBar,
    private validator: ValidatorService
  ) {
    this.token = this.activateRouter.snapshot.params['Token'];
    this.email = this.activateRouter.snapshot.params['Email'];
    this.createResetpassForm();
  }

  ngOnInit() {
    this.showSpinner = false;

    this.usuarioService.verificarUser(this.token).subscribe(
      (resp: any) => {
        this.email = resp.data;
      },
      (err) => {
      // TODO: verificar que esto funcione.
      this.snackBar.open(err.error.statusMsg, 'Aceptar', {
          duration: 5000,
        });

        setTimeout(() => {
          this.router.navigateByUrl('/login');
        }, 5000);
      }
    );
  }

  private createResetpassForm() {
    this.resetpassForm = this.formBuilder.group(
      {
        password: new FormControl(
          null,
          Validators.compose([
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(64),
          ])
        ),
        repeat_password: new FormControl(
          null,
          Validators.compose([
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(64),
          ])
        ),
      },
      {
        validators: [
          this.validator.equalsValidator('password', 'repeat_password'),
        ],
      }
    );
  }

  public fieldValid(fieldName: string): boolean {
    const field = this.resetpassForm.controls[fieldName];

    if (field.valid || field.untouched) {
      return true;
    }
    return false;
  }

  send() {
    this.usuarioService
      .resetPassword(this.email, this.resetpassForm.controls['password'].value)
      .subscribe((resp) => {

        if (resp) {
          this.snackBar.open(
            'Cambio exitoso, redirecionando a login',
            'Aceptar',
            {
              duration: 5000,
            }
          );
          setTimeout(() => {
            this.router.navigateByUrl('/login');
          }, 5000);
        }
      });
  }

  public buttonEnabled(): boolean {
    return this.resetpassForm.valid && this.resetpassForm.dirty;
  }

  public errorHandling = (control: string, error: string) => {
    return this.resetpassForm.controls[control].hasError(error);
  };
}
